package com.eladfinish.bible.contest.ui.scaffold

import androidx.compose.material3.SnackbarDuration
import androidx.compose.material3.SnackbarVisuals
import androidx.compose.ui.text.AnnotatedString

data class AppSnackbarVisuals(
    override val message: String,
    override val actionLabel: String? = null,
    override val withDismissAction: Boolean = false,
    override val duration: SnackbarDuration = SnackbarDuration.Short,
    val kind: MessageKind,

    // Rich text (optional)
    val richText: AnnotatedString? = null,
    val richClicksById: Map<String, () -> Unit> = emptyMap(),
) : SnackbarVisuals
